import React from 'react'

import GenderFields from '../SroiFormContent/sections/StakeholderDetailsSection/StakeholderSection/GenderFields'
import EthnicityFields from '../SroiFormContent/sections/StakeholderDetailsSection/StakeholderSection/EthnicityFields'
import DisabilityPercentageFields from '../SroiFormContent/sections/StakeholderDetailsSection/StakeholderSection/DisabilityPercentageFields'
import ImdPercentageFields from '../SroiFormContent/sections/StakeholderDetailsSection/StakeholderSection/ImdPercentageFields'
import WellbeingFields from '../SroiFormContent/sections/StakeholderDetailsSection/StakeholderSection/WellbeingFields'
import AgeDistributionWithActivityLevels from '../SroiFormContent/sections/StakeholderDetailsSection/StakeholderSection/AgeDistributionWithActivityLevels'

import { COUNTRY_ID } from '../../fields'

const StakeholderMetricsFields = ({ formik, index }) => {
  const { values } = formik

  const country = values[COUNTRY_ID]

  return (
    <>
      <GenderFields formik={formik} index={index} />
      <EthnicityFields formik={formik} index={index} />
      <AgeDistributionWithActivityLevels formik={formik} index={index} />
      <DisabilityPercentageFields formik={formik} index={index} />
      {
        // Hide IMD % fields when country_of_operation: SAU
        country !== 'SAU' && <ImdPercentageFields formik={formik} index={index} />
      }
      <WellbeingFields formik={formik} index={index} />
    </>
  )
}

export default StakeholderMetricsFields
